import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import { useLang } from "../i18n/LangContext";
import { useAppState } from "../state/AppState";

interface SearchFieldProps {
  autoFocus?: boolean;
}

export function SearchField({ autoFocus = false }: SearchFieldProps) {
  const { t } = useLang();
  const { filters, dispatchFilter } = useAppState();
  const hasQuery = filters.q.length > 0;

  return (
    <div className="search">
      <TextField
        type="text"
        size="small"
        fullWidth
        autoComplete="off"
        autoFocus={autoFocus}
        placeholder={t("searchPlaceholder")}
        value={filters.q}
        onChange={(e) => dispatchFilter({ type: "set", patch: { q: e.target.value } })}
        // 16px on the inner input prevents iOS Safari from auto-zooming
        // when the field gains focus.
        sx={{ "& input": { fontSize: 16 } }}
        InputProps={{
          sx: { pl: 1 },
          startAdornment: (
            <InputAdornment position="start" sx={{ mr: 1, color: "text.secondary" }}>
              <SearchOutlinedIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: hasQuery ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                aria-label="clear search"
                onClick={() => dispatchFilter({ type: "set", patch: { q: "" } })}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        }}
      />
    </div>
  );
}
